var PES = PES || {};

PES.MobileNavigation = function () {

    function showElements() {
        let openMenu = '.main-btn__mobile';
        let mobileMenu = '.mobile__menu';
        let closeMobileMenu = '.main-btn__mobile--close';
        let hasMobileDropdown = '[data-mobile-dropdown]';
        let mobileMenuMainItems = '.mobile__menu--content > h3';

        $(hasMobileDropdown).on('click', function (e) {
            let target = e.target;
            $(target).closest('h3')
                .toggleClass('active')
                .siblings('h3')
                .removeClass('active');
        });

        function closeMenu() {
            $(mobileMenu).removeAttr('data-show-menu');
            $('body').removeAttr('data-scroll-locked');
            $(mobileMenuMainItems).removeClass('active');
        };

        $(openMenu).on('click', function () {
            $(mobileMenu).attr('data-show-menu', true);
            $('body').attr('data-scroll-locked', true);
        })

        $(closeMobileMenu).on('click', function () {
            closeMenu();
        })

        $(document).on('keydown', function (event) {
            if (event.key === "Escape" && ($(mobileMenu).attr('data-show-menu') !== false || $(mobileMenu).attr('data-show-menu') !== undefined)) {
                closeMenu();
            }
        });

        $(window).on('resize', function () {
            if (window.outerWidth > 1200 && $(closeMobileMenu).is(':visible')) {
                $(closeMobileMenu).trigger('click');
            }
        })
    }

    var init = function () {
        showElements();
    };

    return {
        init: init
    };
}();